export enum WorkflowStatus {
  unclaimed = 1,
  pending = 2,
  approved = 3,
  declined = 4,
  claimed = 5,
  excluded = 6,
  clarification = 7,
  approvedWithIssues = 8,
  inProgress = 9,
}
